import {
    SET_MARKET_DROP_DOWN_LIST
} from "./MarketType";

const reducer = (state = [], action: any) => {
    switch (action.type) {
        case SET_MARKET_DROP_DOWN_LIST:
            return {
                ...state,
                marketDropDown: action.response,
            };
        default:
            return state;
    }
};

export default reducer;